import React from 'react';
import { Platform, Pressable, View } from 'react-native';
import { VStack } from '@/components/gluestack/vstack';
import { HStack } from '@/components/gluestack/hstack';
import { Card } from '@/components/gluestack/card';
import { Text } from '@/components/gluestack/text';
import { Heading } from '@/components/gluestack/heading';
import { HugeIconsWrapper } from '@/components/ui/HugeIconsWrapper';
import { CheckmarkCircle02Icon } from '@hugeicons-pro/core-solid-rounded';
import { StartUp02Icon } from '@hugeicons-pro/core-stroke-rounded';
import { useTranslation } from 'react-i18next';
import { useCommunity } from '@/hooks/useCommunity';
import { useOpenWebPage } from '@/hooks/useOpenWebPage';
import { PLAN_INFO_URLS } from '@/constants/urls';

const PREMIUM_FEATURES = [
  'unlimitedMessaging',
  'unlimitedPhotos',
  'featureMorePhotosToRegularMembers',
  'morePhotoUploads',
  'moreBlocks',
] as const;

export function PremiumFeatures() {
  const { t } = useTranslation();
  const community = useCommunity();
  const openWebPage = useOpenWebPage();

  const planInfoUrl = community
    ? PLAN_INFO_URLS[community.code]?.[Platform.OS === 'web' ? 'web' : 'native']
    : undefined;

  return (
    <VStack space="md">
      <Heading size="md" className="ml-1 text-typography-700">
        {t('account.plans.includedWith', { planName: community?.premiumPlan })}
      </Heading>

      <Card className="relative overflow-hidden bg-primary-500 dark:bg-primary-400" size="md">
        <View className="absolute right-8 top-0 bottom-0 justify-center opacity-10">
          <HugeIconsWrapper icon={StartUp02Icon} className="text-white" size={140} />
        </View>

        <VStack space="sm">
          {PREMIUM_FEATURES.map((feature) => (
            <HStack key={feature} space="sm" className="items-start">
              <HugeIconsWrapper icon={CheckmarkCircle02Icon} size={20} className="text-white" />
              <Text className="text-white font-semibold">
                {t(`account.plans.premiumFeatures.${feature}`)}
              </Text>
            </HStack>
          ))}

          {planInfoUrl ? (
            <Pressable onPress={() => openWebPage(planInfoUrl)} className="mt-1">
              <Text underline className="text-white font-semibold">
                {t('account.plans.learnMoreAboutPlans')}
              </Text>
            </Pressable>
          ) : null}
        </VStack>
      </Card>
    </VStack>
  );
}

